jQuery( function ( $ ) {

    const $sections = $( 'section.featured_products' );
    if ( !$sections.length ) { return; }


    // from https://stackoverflow.com/questions/8495687/split-array-into-chunks
    function chunk ( array, per_chunk ) {
        return array.reduce((all,one,i) => {
            const ch = Math.floor(i/per_chunk); 
            all[ch] = [].concat((all[ch]||[]),one); 
            return all
         }, [])
    }

    function calculate_category_heights () {
        let per_chunk = null;
        $sections.each( function () {
            const $cols = $( '.product-loop > *', this );
            per_chunk = per_chunk ?? Math.round( $cols.first().parent().outerWidth( true ) / $cols.first().outerWidth( true ) );
            // chunk and calc height
            chunk( $cols.toArray(), per_chunk ).forEach( chunk => {
                const $chunk_categories = $( '.category', $( chunk ) );
                $chunk_categories.height( 'auto' );
                let height = 0;
                chunk.forEach( el => {
                    height = Math.max( height, $( '.category', el ).height() );
                });
                $chunk_categories.height( height );
            });
        });
    }

    calculate_category_heights();
    $( window ).on( 'breakpoint_changed', calculate_category_heights );

});